var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reserve"},[_c('h1',[_vm._v("预订座位")]),_c('p',[_vm._v("请填写您的预订信息。")])])
}]

export { render, staticRenderFns }